import { render, staticRenderFns } from "./Structure_Header_Col2.vue?vue&type=template&id=66975a9b&"
import script from "./Structure_Header_Col2.vue?vue&type=script&lang=js&"
export * from "./Structure_Header_Col2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports